import { pipe } from 'fp-ts/function';
import { array, option, record, string } from 'fp-ts';
import { TextKey } from '@mews-commander/enums';
import { getExternalPayments } from '../../constants';
import { SectionProps } from '../../types';
import { FormSection } from './FormSection';

export const ExternalPayments = ({ accountingEnvironment, options }: SectionProps) => {
    const listOfExternalPayments = pipe(
        accountingEnvironment.allowedExternalPaymentTypes,
        option.fromNullable,
        option.map((it) =>
            pipe(
                it,
                array.map((item) =>
                    pipe(
                        item.externalPaymentTypeFieldName,
                        option.fromNullable,
                        option.map((fieldName) => pipe(fieldName, string.toUpperCase))
                    )
                )
            )
        ),
        option.fold(() => [] as string[], array.compact)
    );

    const items = pipe(
        getExternalPayments(),
        record.filterWithIndex((key, _) => listOfExternalPayments.includes(key.toUpperCase()))
    );

    return (
        <FormSection
            items={items}
            prefix="externalPayments"
            options={options}
            titleTextKey={TextKey.ExternalPaymentPlural}
        />
    );
};
